import { render, staticRenderFns } from "./Appraisals-list.vue?vue&type=template&id=697681cf&scoped=true&"
import script from "./Appraisals-list.vue?vue&type=script&lang=js&"
export * from "./Appraisals-list.vue?vue&type=script&lang=js&"
import style0 from "./Appraisals-list.vue?vue&type=style&index=0&id=697681cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697681cf",
  null
  
)

export default component.exports